import React, { useEffect, useState } from 'react';
import { KTSVG } from '../../../../../../../../../_metronic/helpers';
import { getItemServiceAll } from '../../../../../../../../services/itemServiceService';
import { Loading } from '../../../../../../../components/Loadings/loading';
import { useToast } from '../../../../../../../components/Toats';
import { ModalAddDescontoOS } from './components/modalAddDescontoOS';
import { ModalAddServiceOS } from './components/modalAddServiceOS';
import { useAuth } from '../../../../../../../../modules/auth';
import { ModalDeleteItemService } from './components/modalDeleteServiceOS';

type Props = {
  itemOrderOfService: any;
  refresh: any
}

export function ServicesQtdOS({itemOrderOfService, refresh} : Props) {
    const [loading, setLoading] = useState<boolean>(false)
    const [isCardOpen, setIsCardOpen] = useState<boolean>(true);
    const [itensServices, setItensServices] = useState<any[]>([])
    const [myItemService, setMyItemService] = useState<any>(null)
    const [showModalAddService, setShowModalAddService] = useState<boolean>(false)
    const [showModalAddDesconto, setShowModalAddDesconto] = useState<boolean>(false)
    const [showModalDelete, setShowModalDelete] = useState<boolean>(false)
    const { toggleToast } = useToast();
    const {currentUser} = useAuth()

    const getItensService = async () => {
      try {
        if(itemOrderOfService && itemOrderOfService.id){
          setLoading(true)
          const myItensServices = await getItemServiceAll(itemOrderOfService && itemOrderOfService.id ? itemOrderOfService.id : "")
          setItensServices(myItensServices)
        }
      } catch (error) {
          console.log(error)
          toggleToast("Erro ao buscar os itens do serviço. ", "error")
      }finally{
          setLoading(false)
      }
    }

    const refreshV2 = () =>{
      getItensService()
    }

    useEffect(() => {
      if(itemOrderOfService && itemOrderOfService.id){
        getItensService()
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itemOrderOfService])

    if (loading) {
      return (
        <div className='spinnerLoadingDashboard'>
          <Loading myClass='spinner-border spinnerDashboard'/>
        </div>
      );
    }

  return (
    <div className='card' style={{}}>
        <div
          className='card-header border-0 cursor-pointer'
          role='button'
          onClick={() => setIsCardOpen((prev) => !prev)}
          aria-expanded={isCardOpen}
          aria-controls='kt_account_profile_details'
        >
          <div className='card-title m-0' style={{justifyContent: 'space-between', width: '100%'}}>
            <h3 className='fw-bolder m-0'>Itens {itensServices ? `(${itensServices.length})` : "(0)"}</h3>
            {currentUser && currentUser.role && currentUser.role.slug && currentUser.role.slug !== 'CLIENTE' && 
              <button
                  className='btn btn-lg text-hover-primary'
                  style={{padding: '0rem'}}
                  onClick={(event) => {
                      event.stopPropagation();
                      setShowModalAddService(true)
                      //setShowModalDescriptionOS(true)
                  }}
                  type="button"
              >
                <KTSVG className='svg-icon-muted svg-icon-2hx' path='/media/icons/duotune/general/gen035.svg' />
              </button>
            }
          </div>
        </div>

        <div id='kt_account_profile_details_service' className={`collapse ${isCardOpen ? 'show' : ''}`}>
          <div>
            <div className='card-body border-top p-9'>

              <div className='table-responsive'>
                <table className='table table-row-dashed table-hover table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead className='bg-light'>
                    <tr className='text-muted text-start fw-bolder fs-7 text-uppercase gs-0'>
                      <th className='min-w-400px'>Tipo</th>
                      <th className='min-w-400px'>Item</th>
                      <th className='min-w-100px'>Valor Unit.</th>
                      <th className='min-w-100px'>Qtd</th>
                      <th className='min-w-100px'>Total</th>
                      <th className='min-w-100px text-end'>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      itensServices && itensServices.map((itemService) => {
                        return (
                          <tr>
                            <td>
                                <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                  {
                                    itemService 
                                    && itemService.tipo 
                                    ? itemService.tipo
                                    : "Não identificado. "
                                  }
                                </a>
                            </td>
                            <td>
                                <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                  {
                                    itemService ? 
                                      itemService.tipo === "SERVICO" ? 
                                        itemService.typeService 
                                        && itemService.typeService.description 
                                        ? itemService.typeService.description 
                                        : "Não identificado. "
                                      : 
                                      itemService.tipo === "PRODUTO" ?
                                        itemService.product 
                                          && itemService.product.name 
                                          ? itemService.product.name 
                                          : "Não identificado. " 
                                      : "Não identificado"
                                    : "Não identificado. "
                                  }
                                </a>
                            </td>
                            <td>
                                <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                  R$ {" "}
                                  
                                  {`${itemService && itemService.value && itemService.value > 0 
                                  ? itemService.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace('R$', '').trim() 
                                  : '0,00'}`}
                                  
                                  {/* {
                                    itemService 
                                    && itemService.value
                                    ? itemService.value
                                    : "0"
                                  },00 */}
                                </a>
                            </td>
                            <td>
                                <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                  {
                                    itemService 
                                    && itemService.amount
                                    ? itemService.amount
                                    : "0"
                                  }
                                </a>
                            </td>
                            <td>
                                <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                  R$ {" "}
                                  
                                  {`${itemService && itemService.sub_value && itemService.sub_value > 0 
                                  ? itemService.sub_value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace('R$', '').trim() 
                                  : '0,00'}`}
                                  {/* {
                                    itemService 
                                    && itemService.sub_value
                                    ? itemService.sub_value
                                    : "0"
                                  },00 */}
                                </a>
                            </td>
                            <td style={{display: 'flex', justifyContent: 'end'}}>
                              {currentUser && currentUser.role && currentUser.role.slug !== 'CLIENTE' && (
                                <a
                                    onClick={(event: any) => {
                                      event.preventDefault()
                                      setMyItemService(itemService)
                                      setShowModalDelete(true)
                                    }}
                                    href='#'
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                >
                                    <KTSVG
                                    path='/media/icons/duotune/general/gen027.svg'
                                    className='svg-icon-3'
                                    />
                                </a>
                              )}
                            </td>
                          </tr>
                        )
                      })
                    }
                    
                  </tbody>
                </table>
              </div>

              <div style={{display: 'flex', justifyContent: 'end', flexDirection: 'column', alignItems: 'end'}}>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bold fs-5 mb-1'>Sub Total: </span>
                  <span className='text-muted mt-1 fw-semibold fs-5'>
                    {/* {itemOrderOfService && itemOrderOfService.value_sub_final ? itemOrderOfService.value_sub_final : "0"},00 */}
                    R$ {" "}
                    {`${itemOrderOfService && itemOrderOfService.value_sub_final && itemOrderOfService.value_sub_final > 0 
                    ? itemOrderOfService.value_sub_final.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace('R$', '').trim() 
                    : '0,00'}`}
                  
                  </span>
                </h3>
                <h3 className='card-title' style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '0.4rem'}}>
                  <a 
                    href='#' 
                    className='text-primary fw-bold text-hover-muted d-block fs-5'
                    onClick={() => {
                      if(currentUser && currentUser.role && currentUser.role.slug && currentUser.role.slug !== 'CLIENTE'){
                        setShowModalAddDesconto(true)
                      }
                    }}
                  >
                    + Desconto:
                  </a>
                  <span className='text-muted mt-1 fw-semibold fs-5'>
                    {/* {itemOrderOfService && itemOrderOfService.value_discont ? itemOrderOfService.value_discont : "0"},00 */}
                    R$ {" "}
                    {`${itemOrderOfService && itemOrderOfService.value_discont && itemOrderOfService.value_discont > 0 
                    ? itemOrderOfService.value_discont.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace('R$', '').trim() 
                    : '0,00'}`}
                  </span>
                </h3>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bold fs-5 mb-1'>Total: </span>
                  <span className='text-muted mt-1 fw-semibold fs-5'>
                    {/* {itemOrderOfService && itemOrderOfService.value_final ? itemOrderOfService.value_final : "0"},00 */}
                    R$ {" "}
                    {`${itemOrderOfService && itemOrderOfService.value_final && itemOrderOfService.value_final > 0 
                    ? itemOrderOfService.value_final.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace('R$', '').trim() 
                    : '0,00'}`}

                  </span>
                </h3>
              </div>

            </div>



            {/* <div className='card-footer d-flex justify-content-end py-6 px-9'>
              <button
                className='btn btn-primary'>
                {!loading && 'Salvar Descrição'}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Please wait...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div> */}
          </div>
        </div>

        <ModalAddServiceOS
          idService={itemOrderOfService && itemOrderOfService.id ? itemOrderOfService.id : ""}
          show={showModalAddService} 
          handleClose={() => {
            setShowModalAddService(false)
            refresh()
            refreshV2()
          }}
        />

        <ModalAddDescontoOS
          show={showModalAddDesconto}
          id={itemOrderOfService && itemOrderOfService.id ? itemOrderOfService.id : null}
          data={itemOrderOfService} 
          handleClose={() => {
            setShowModalAddDesconto(false)
            refresh()
            refreshV2()
          }}
        />

        <ModalDeleteItemService 
          show={showModalDelete}
          data={myItemService}
          id={myItemService ? myItemService.id : undefined} 
          handleClose={() => {
            setMyItemService(null)
            setShowModalDelete(false)
            refresh()
            refreshV2()
          }} 
        />
      </div>
  );
}